import { __assign, __extends } from "tslib";
import React from 'react';
import BaseViewer from './Base';
import omit from 'lodash/omit';
import mergeTheme from '../Themes/mergeTheme';
import baseTheme from '../Themes/Viewer/donation.scss';
var DonationViewer = /** @class */ (function (_super) {
    __extends(DonationViewer, _super);
    function DonationViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.theme = mergeTheme(baseTheme, _this.props.theme);
        return _this;
    }
    DonationViewer.prototype.render = function () {
        var restProps = omit(this.props, ['theme']);
        return (React.createElement("div", { className: 'da-editor-donation' },
            React.createElement(BaseViewer, __assign({ theme: this.theme }, restProps, { fixedParagraph: false }))));
    };
    return DonationViewer;
}(React.Component));
export default DonationViewer;
//# sourceMappingURL=Donation.js.map